/**
 * Created by pmnia on 8/1/15.
 */
(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('obtSocket', obtSocket );

    obtSocket.$inject = ['socketFactory'];
    /* @ngInject */
    function obtSocket(socketFactory) {
        var instance = null;
        var instance_server_url = null;
        var ioSocket = null;
        var default_server_url = 'https://dev.martinblouin.com:8080';

        //SOURCE: https://github.com/btford/angular-socket-io/issues/69
        //source ; http://stackoverflow.com/questions/16518153/get-connection-status-on-socket-io-client
        return {
            connected:function(){
                //if(ioSocket){
                //    console.log('>>>>>>>>>>', ioSocket );
                //}

                if(ioSocket){
                    return ioSocket.connected;
                }
                return false;
            },
            getSocket : function(server, port){
                //var url = 'https://dev.martinblouin.com:8080';
                try{
                    if(server){
                        var new_instance_server_url = port? server + ':' + port : server;
                        if(instance && instance_server_url == new_instance_server_url){
                            return instance; // the optimze and retunn the same socket instance.
                        }else{
                            instance_server_url = new_instance_server_url;
                        }
                    }else if(!instance_server_url){
                        instance_server_url = default_server_url;
                    }

                    var options = {
                        'reconnection delay': 1000,
                        'reconnection limit': 1000,
                        'max reconnection attempts': 'Infinity'
                    };

                    ioSocket = io.connect(instance_server_url, options);
                    instance = socketFactory({ioSocket:ioSocket});
                    return instance;

                }catch(err){
                    return null;
                }
            }
        };
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/core/socket.services.js
 ** module id = 100
 ** module chunks = 0
 **/